import React from 'react'
import dayjs from 'dayjs'
import { BtnV2, Icon, l, SectionMessage } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { AccountStatus } from 'common/core/models/Account/constants'
import { isTrialStatus } from 'common/core/models/Account/helpers'
import { getAccountStatus } from 'common/core/selectors/appSelectors'
import { analyticsService } from 'utils/services/analytics'

import { WhatYouWillLoseItems } from './constants'

interface IWhatLosesStep {
  periodEnds?: string | null
  loading: boolean
  status?: AccountStatus
  onClose: () => void
  onNextStep: () => void
}

const WhatLosesStep = ({ loading, periodEnds, status, onClose, onNextStep }: IWhatLosesStep) => {
  const date = dayjs(periodEnds).format('D MMM YYYY')
  const accountStatus = useAppSelector(getAccountStatus)
  const isTrial = isTrialStatus(accountStatus)

  const handleClose = () => {
    onClose()
    analyticsService.sendEvent('SETTINGS.BILLING.CANCEL_MODAL.WHAT_LOSES.CLOSE')
  }

  const handleChangeStep = () => {
    onNextStep()
    analyticsService.sendEvent('SETTINGS.BILLING.CANCEL_MODAL.WHAT_LOSES.CANCEL_SUBSCRIPTION')
  }

  React.useEffect(() => {
    analyticsService.sendEvent('SETTINGS.BILLING.CANCEL_MODAL.WHAT_LOSES.SHOW')
  }, [])
  return (
    <>
      <div className="p-a-lg">
        <h1>{l.translate('What you will lose')}</h1>
        <p className="m-b-0 text-subheading">
          {l.translate(
            'By canceling your subscription, you will lose access to all paid features and the ability to:',
          )}
        </p>
        <div className="row">
          {WhatYouWillLoseItems.map((item) => (
            <div
              className="md-col-4 col-12 flex-col align-center m-t-lg md-d-block d-flex md-p-r-md p-r-0"
              key={item.title.message}
            >
              <div className="text-center p-a">
                <img src={item.image} alt={l.translate('what you lose')} />
              </div>
              <p className="text-subheading m-b-xs">{l.getString(item.title)}</p>
              <span className="text-body-sm">
                {item.benefits.map((benefit) => (
                  <span
                    className="d-flex align-center text-secondary m-y-xxs"
                    key={benefit.message}
                  >
                    <Icon.Tick size={20} style={{ minWidth: 20 }} className="m-r-xxs" />
                    {l.getString(benefit)}
                  </span>
                ))}
              </span>
            </div>
          ))}
        </div>
        <SectionMessage
          variant="info"
          className="m-t-md"
          title={
            !isTrial
              ? l.translate('You will be able to use your subscription features until {date}.', {
                  date,
                })
              : undefined
          }
          description={
            isTrial
              ? l.translate(
                  'Cancelling Trial Period is irreversible and disables access to paid features immediately. You will need to upgrade if you’d like to return access back.',
                )
              : l.translate(
                  'After this date, you will only have access to free features with corresponding limitation and branding.',
                )
          }
        />
      </div>
      <div className="p-y-xs p-x b-t row between">
        <BtnV2 onClick={handleClose}>{l.translate('I changed my mind')}</BtnV2>
        <BtnV2 onClick={handleChangeStep} loading={loading} variant="danger-light">
          {l.translate('Cancel my subscription')}
        </BtnV2>
      </div>
    </>
  )
}

export default WhatLosesStep
